export default __webpack_public_path__ + "static/media/cirus.08cb027d.svg";